export const decemberAbbreviatedLowercase = "Pqa";
export default {decemberAbbreviatedLowercase};